function getVideoEmbedData( url ) {
    const videoOptions = {
        width: 960,
        aspectRatio: '16 / 9',
    };

    const rutubeMatch = url.match( /rutube\.ru\/(?:video|play\/embed)\/([a-f0-9]+)/i );

    if ( rutubeMatch ) {
        return {
            src: `https://rutube.ru/play/embed/${rutubeMatch[1]}`,
            type: 'iframe',
            preload: false,
            ...videoOptions,
        };
    }

    if ( /(?:vkvideo\.ru|vk\.com)/i.test( url ) ) {
        const vkExtMatch = url.match( /video_ext\.php\?([^#]+)/i );

        if ( vkExtMatch ) {
            return {
                src: `https://vkvideo.ru/video_ext.php?${vkExtMatch[1]}`,
                type: 'iframe',
                preload: false,
                ...videoOptions,
            };
        }

        const vkMatch = url.match( /video(-?)(\d+)_(\d+)/i );

        if ( vkMatch ) {
            const oid = vkMatch[1] === '-' ? `-${vkMatch[2]}` : vkMatch[2];
            const videoId = vkMatch[3];

            return {
                src: `https://vkvideo.ru/video_ext.php?oid=${oid}&id=${videoId}&hd=2&autoplay=1`,
                type: 'iframe',
                preload: false,
                ...videoOptions,
            };
        }
    }

    if ( /\.(mp4|webm|ogg|mov)(\?|#|$)/i.test( url ) ) {
        return {
            src: url,
            type: 'html5video',
            ...videoOptions,
        };
    }

    return null;
}

document.addEventListener( 'DOMContentLoaded', function () {

    // Оборачиваем изображения в ссылки
    if (isExist('.typography .wp-block-image')) {
        let wpImage = document.querySelectorAll('.typography .wp-block-image');

        wpImage.forEach((image) => {
            const imgElement = image.querySelector('img'),
                figcaptionElement = image.querySelector('figcaption'),
                src = imgElement.src;

            if (!image.parentElement.classList.contains('wp-block-gallery')) {

                if (imgElement && figcaptionElement) {
                    let org_html = image.innerHTML;

                    org_html = org_html.replace(/<figcaption\b[^>]*>.*?<\/figcaption>/i, '');

                    image.innerHTML = `<a href="${src}" data-fancybox>${org_html}</a>${figcaptionElement.outerHTML}`;
                } else {
                    const org_html = image.innerHTML;
                    image.innerHTML = `<a href="${src}" data-fancybox>${org_html}</a>`;
                }
            }
        });
    }

    // Галереи на дефолтной странице
    if (isExist('.typography .wp-block-gallery')) {
        let wpGalleries = document.querySelectorAll('.typography .wp-block-gallery');

        wpGalleries.forEach((gallery, index) => {
            let wpImages = gallery.querySelectorAll('.wp-block-image');
            let minHeight = Number.MAX_SAFE_INTEGER;

            wpImages.forEach((image) => {
                if (image.querySelector(':scope > a')) {
                    return;
                }

                const imgElement = image.querySelector('img'),
                    figcaptionElement = image.querySelector('figcaption'),
                    src = imgElement.src;

                if (imgElement && figcaptionElement) {
                    let org_html = image.innerHTML;

                    org_html = org_html.replace(/<figcaption\b[^>]*>.*?<\/figcaption>/i, '');

                    image.innerHTML = `<a href="${src}" data-fancybox="gallery-${index}">${org_html}</a>${figcaptionElement.outerHTML}`;
                } else {
                    const org_html = image.innerHTML;
                    image.innerHTML = `<a href="${src}" data-fancybox="gallery-${index}">${org_html}</a>`;
                }

                // Добавление проверки изображений на высоту и присваивания всем минимальной высоты
                const height = image.offsetHeight;

                if (height < minHeight) {
                    minHeight = height;
                }
            });

            // wpImages.forEach((img) => {
            //     img.style.height = `${minHeight}px`;
            // });
        });
    }

    // Видео на дефолтной странице
    if (isExist('.typography .block-video')) {
        let wpVideos = document.querySelectorAll('.typography .block-video');

        wpVideos.forEach((video) => {
            const videoLink = video.querySelector('.block-video__link');

            if (!videoLink) {
                return;
            }

            const embedData = getVideoEmbedData(videoLink.href);

            if (!embedData) {
                return;
            }

            videoLink.href = embedData.src;
            videoLink.dataset.fancybox = '';
            videoLink.dataset.type = embedData.type;
            videoLink.dataset.width = embedData.width;
            videoLink.dataset.aspectRatio = embedData.aspectRatio;

            if (embedData.preload === false) {
                videoLink.dataset.preload = 'false';
            }
        });
    }
} );